import React, { Component } from 'react'
import PropTypes from 'prop-types'

import AppStore from '../../../store/AppStore'
import DtoUser from '../../../home/dto/DtoUser'
import SelectionAction from '../../../dashboard/actions/SelectionAction'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoSelectionRow from '../../../dashboard/dto/DtoSelectionRow'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import DialogTitle from '@material-ui/core/DialogTitle'
import { css } from 'glamor'
import ToastrAction from '../../../home/actions/ToastrAction'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ ref } { ...props } />
})

class SelectionDeleteModal extends Component {

	constructor(props) {
		super(props)
	}

	handleClose = () => {
		AppStore.dispatch(SelectionAction.closeModalSelectionDelete())
	}
	validate = () => {
		if (this.props.selectedSelectionInformation.id) {
			AppStore.dispatch(SelectionAction.deleteSelection(this.props.user.login, this.props.selectedSelectionInformation.id))
		} else {
			AppStore.dispatch(ToastrAction.warning(i18n.warning.noSelectionDeletion))
		}
	}
	getContent = () => {
		if (this.props.selectedSelectionInformation && this.props.modalSelectionDelete) {
			return (
				<div className='row'>
					{ i18n.question.deleteSelection }
				</div>
			)
		}
		return null
	}
	getTitle = () => {
		if (this.props.selectedSelectionInformation && this.props.modalSelectionDelete) {
			return (
				<DialogTitle id='alert-dialog-slide-title'>{ i18n.deleteSelection } : { this.props.selectedSelectionInformation.title }</DialogTitle>
			)
		}
		return null
	}

	render() {
		return (
			<Dialog
				maxWidth='sm'
				fullWidth={ true }
				TransitionComponent={ Transition }
				modal={ false }
				keepMounted
				open={ this.props.modalSelectionDelete }
				onClose={ this.handleClose }
			>
				{ this.getTitle() }
				{ this.getContent() }
				<DialogActions>
					<Button onClick={ this.handleClose } { ...css({ backgroundColor: 'red !important', color: 'white !important' }) }>
						{ i18n.cancel }
					</Button>
					<Button onClick={ this.validate } { ...css({ backgroundColor: '#53A1FF !important', color: 'white !important' }) } autoFocus>
						{ i18n.deleteFunction }
					</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

SelectionDeleteModal.propTypes = {
	selectedSelectionInformation: PropTypes.instanceOf(DtoSelectionRow),
	modalSelectionDelete: PropTypes.bool,
	user: PropTypes.instanceOf(DtoUser)
}

const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user,
		selectedSelectionInformation: store.SelectionReducer.selectedSelectionInformation,
		modalSelectionDelete: store.SelectionReducer.modalSelectionDelete
	}
}

export default connect(mapStateToProps)(SelectionDeleteModal)



// WEBPACK FOOTER //
// ./src/components/modal/selection/SelectionDeleteModal.js